<template>
  <div>
    <form
      v-if="
        (reservation && $store.state.cart.reservations.count > 0) ||
          (!reservation && $store.state.cart.total > 0)
      "
      @submit.prevent="validateBeforeSubmit"
    >
      <section class="personal-information">
        <header class="personal-information__header">
          <headline>{{ $t('title') }}</headline>
          <c-cart-timer class="personal-information__timer" />
        </header>

        <div class="personal-information__content">
          <p class="personal-information__fine-print">
            * {{ $t('mandatoryFields') }}
          </p>

          <div class="form-input personal-information__input">
            <label
              for="firstname"
              class="form-input__label sr-only"
            >{{ $t('formFields.firstName') }}</label>
            <span
              v-if="hasError('firstName')"
              class="form-input__error"
            >{{ $t('errors.' + getError('firstName')) }}</span>
            <input
              id="firstname"
              v-model="personalInformation.firstName"
              class="form-input__input"
              type="text"
              name="firstname"
              :placeholder="$t('formFields.firstName') + ' *'"
              required
            >
          </div>

          <div class="form-input personal-information__input">
            <label
              for="lastname"
              class="form-input__label sr-only"
            >{{ $t('formFields.lastName') }}</label>
            <span
              v-show="hasError('lastName')"
              class="form-input__error"
            >{{ $t('errors.' + getError('lastName')) }}</span>
            <input
              id="lastname"
              v-model="personalInformation.lastName"
              class="form-input__input"
              type="text"
              name="lastname"
              :placeholder="$t('formFields.lastName') + ' *'"
              required
            >
          </div>

          <div class="form-input personal-information__input">
            <label
              for="email1"
              class="form-input__label sr-only"
            >{{ $t('formFields.email') }}</label>
            <span
              v-show="hasError('email1')"
              class="form-input__error"
            >{{ $t('errors.' + getError('email1')) }}</span>
            <input
              id="email1"
              v-model="personalInformation.email1"
              class="form-input__input"
              type="email"
              name="email1"
              :placeholder="$t('formFields.email') + ' *'"
              required
            >
          </div>

          <div class="form-input personal-information__input">
            <label
              for="email2"
              class="form-input__label sr-only"
            >{{ $t('formFields.emailRepeat') }}</label>
            <span
              v-if="hasError('email2')"
              class="form-input__error"
            >{{ $t('errors.' + getError('email2')) }}</span>
            <input
              id="email2"
              v-model="personalInformation.email2"
              class="form-input__input"
              type="email"
              name="email2"
              :placeholder="$t('formFields.emailRepeat') + ' *'"
              required
            >
          </div>

          <template v-if="!isGiftCardOrder">
            <p
              v-if="$store.state.cart.tickets.total_articles > 0"
              class="personal-information__note"
            >
              {{ $t('visitorOrigin.note') }}
            </p>

            <fieldset
              v-for="aIndex in totalTicketCount"
              :key="aIndex"
            >
              <legend>
                {{ aIndex }}. {{ $t('visitorOrigin.person') }} <i>{{ ticketType(aIndex) }}</i> {{ $t('visitorOrigin.comesFrom') }}
              </legend>

              <div class="form-input personal-information__input">
                <span
                  v-show="hasError('selectedCountries_' + (aIndex - 1))"
                  class="form-input__error"
                >{{ $t('errors.' + getError('selectedCountries_' + (aIndex - 1))) }}</span>
                <select
                  v-model="personalInformation.selectedCountries[aIndex - 1]"
                  name="country"
                  class="form-input__input form-input__input--select"
                  required
                >
                  <option
                    value=""
                    selected
                    disabled
                  >
                    {{ $t('visitorOrigin.country') }} *
                  </option>
                  <option
                    v-for="countryId in countrySorting"
                    :key="countryId"
                    :value="countryId"
                    :selected="countryId === personalInformation.selectedCountries[aIndex - 1]"
                  >
                    {{ countryLabels[countryId] }}
                  </option>
                </select>
              </div>

              <p>
                {{ $t('visitorOrigin.alreadyVisited') }}
                <span
                  v-show="hasError('wasInMiWuLa_' + (aIndex - 1))"
                  class="form-input__error"
                >
                  {{ $t('errors.' + getError('wasInMiWuLa_' + (aIndex - 1))) }}
                </span>
              </p>

              <div class="form-input form-input--inline form-input--radio">
                <label class="form-input__label">
                  <input
                    v-model="personalInformation.wasInMiWuLa[aIndex - 1]"
                    type="radio"
                    class="form-input__radio"
                    :name="'wim_' + aIndex"
                    value="1"
                    @click="trackReturning(1)"
                  >
                  {{ $t('formFields.visited.yes') }}
                </label>
              </div>

              <div class="form-input form-input--inline form-input--radio">
                <label class="form-input__label">
                  <input
                    v-model="personalInformation.wasInMiWuLa[aIndex - 1]"
                    type="radio"
                    class="form-input__radio"
                    :name="'wim_' + aIndex"
                    value="0"
                    @click="trackReturning(0)"
                  >
                  {{ $t('formFields.visited.no') }}
                </label>
              </div>

              <div class="form-input form-input--inline form-input--radio">
                <label class="form-input__label">
                  <input
                    v-model="personalInformation.wasInMiWuLa[aIndex - 1]"
                    type="radio"
                    class="form-input__radio"
                    :name="'wim_' + aIndex"
                    value="-1"
                    @click="trackReturning(-1)"
                  >
                  {{ $t('formFields.visited.none') }}
                </label>
              </div>

              <template v-if="$store.state.config.contact_data">
                <p><br>{{ $t('coronaHeader') }} **</p>

                <div class="form-input personal-information__input">
                  <label
                    :for="'survey_names_' + (aIndex - 1)"
                    class="form-input__label sr-only"
                  >{{ $t('formFields.surveyName') }}</label>
                  <input
                    :id="'survey_names_' + (aIndex - 1)"
                    v-model="personalInformation.names[aIndex - 1]"
                    class="form-input__input"
                    type="input"
                    :placeholder="$t('formFields.surveyName') + ' *'"
                    required
                  >
                </div>

                <div class="form-input personal-information__input">
                  <label
                    :for="'survey_addresses_' + (aIndex - 1)"
                    class="form-input__label sr-only"
                  >{{ $t('formFields.surveyAddress') }}</label>
                  <input
                    :id="'survey_addresses_' + (aIndex - 1)"
                    v-model="personalInformation.addresses[aIndex - 1]"
                    class="form-input__input"
                    type="input"
                    :placeholder="$t('formFields.surveyAddress') + ' *'"
                    required
                  >
                </div>

                <div class="form-input personal-information__input">
                  <label
                    :for="'survey_locations_' + (aIndex - 1)"
                    class="form-input__label sr-only"
                  >{{ $t('formFields.surveyLocation') }}</label>
                  <input
                    :id="'survey_locations_' + (aIndex - 1)"
                    v-model="personalInformation.locations[aIndex - 1]"
                    class="form-input__input"
                    type="input"
                    :placeholder="$t('formFields.surveyLocation') + ' *'"
                    required
                  >
                </div>

                <div class="form-input personal-information__input">
                  <label
                    :for="'survey_phones_' + (aIndex - 1)"
                    class="form-input__label sr-only"
                  >{{ $t('formFields.surveyPhone') }}</label>
                  <input
                    :id="'survey_phones_' + (aIndex - 1)"
                    v-model="personalInformation.phones[aIndex - 1]"
                    class="form-input__input"
                    type="input"
                    :placeholder="$t('formFields.surveyPhone') + ' *'"
                    required
                  >
                </div>
              </template>
            </fieldset>
            <p v-if="$store.state.config.contact_data">
              **) {{ $t('coronaHint') }}<br><br>
            </p>
          </template>

          <div class="form-input form-input--checkbox">
            <label class="form-input__label">
              <input
                v-model="personalInformation.newsletter"
                type="checkbox"
                class="form-input__checkbox"
                @click="trackNewsletter"
              >
              {{ $t('formFields.newsletter') }}
            </label>
          </div>

          <div
            v-if="!reservation"
            class="form-input form-input--checkbox"
          >
            <label class="form-input__label">
              <input
                v-model="personalInformation.mergeTickets"
                type="checkbox"
                class="form-input__checkbox"
              >
              {{ $t(isGiftCardOrder ? 'formFields.mergeGiftcards' : 'formFields.mergeTickets') }}
            </label>
          </div>
        </div>

        <footer
          v-if="reservation"
          class="personal-information__footer"
        >
          <div class="form-input form-input--checkbox">
            <span
              v-if="hasError('terms')"
              class="form-input__error"
            >{{ $t('errors.' + getError('terms')) }}</span>
            <label class="form-input__label">
              {{ $t('formFields.terms.reservation') }}&nbsp;<a
                :href="$t('formFields.terms.routerLink')"
                target="_blank"
              >{{ $t('formFields.terms.linkText') }}</a>.
            </label>
          </div>

          <button-group align="center">
            <action-link
              :router-link="$t('changeReservation.link')"
              exact
            >
              <icon
                type="chevron-left"
                :size="0.75"
              />
              {{ $t('changeReservation.text') }}
            </action-link>

            <action
              type="submit"
              color="primary"
              @click="startReservation"
            >
              <loader-spinner
                v-show="loadingPayment"
                size="0.7"
              />
              <span v-html="$t('continueReservation.text')" />
              <icon
                type="chevron-right"
                :size="0.75"
              />
            </action>
          </button-group>
        </footer>
      </section>

      <c-cart-booking embedded />

      <section class="personal-information">
        <div class="personal-information__terms form-input form-input--checkbox">
          <span
            v-if="hasError('terms')"
            class="form-input__error"
          >{{ $t('errors.' + getError('terms')) }}</span>
          <label class="form-input__label">
            <input
              v-model="personalInformation.terms"
              type="checkbox"
              class="form-input__checkbox"
            >
            <span>{{ $t('formFields.terms.label1') }} <a
              :href="$t('formFields.terms.routerLink')"
              target="_blank"
            >{{ $t('formFields.terms.linkText') }}</a> {{ $t('formFields.terms.label2') }}</span>
          </label>
        </div>

        <header class="personal-information__header">
          <headline level="2">
            {{ $t('continueOrder.title') }}
          </headline>
        </header>

        <div
          id="payment_selection"
          class="payment__container"
        >
          <action
            v-for="payment in payments"
            :id="'payment_' + payment.clearingtype + '_' + payment.wallettype"
            :key="payment.name"
            :disabled="payment.processing"
            color="payment"
            type="submit"
            @click="setPayment(payment)"
          >
            <span
              class="payment__wrapper"
              v-html="payment.icon"
            />
          </action>
        </div>

        <div id="payment_form">
          <div
            v-show="showCC"
            class="payment__data"
          >
            <headline class="personal-information__sub-title personal-information__header">
              {{ $t('payment.cc.title') }}
            </headline>

            <fieldset>
              <div
                v-if="loadingPayment"
                class="payment__overlay"
              >
                <div class="payment__overlay--curtain" />
                <div class="payment__overlay--content">
                  <span>{{ $t('payment.label.wait') }}</span>
                  <loader-spinner size="0.7" />
                </div>
              </div>

              <div class="grid grid--large">
                <div class="grid__item grid__item--1/2">
                  <div class="form-input">
                    <label
                      for="firstname-cc"
                      class="form-input__label"
                    >{{ $t('payment.cc.firstname') }}:</label>
                    <input
                      id="firstname-cc"
                      type="text"
                      name="firstname"
                      value=""
                      class="form-input__input"
                    >
                  </div>
                </div>
                <div class="grid__item grid__item--1/2">
                  <div class="form-input">
                    <label
                      for="lastname-cc"
                      class="form-input__label"
                    >{{ $t('payment.cc.lastname') }}:</label>
                    <input
                      id="lastname-cc"
                      type="text"
                      name="lastname"
                      value=""
                      class="form-input__input"
                    >
                  </div>
                </div>
              </div>

              <div class="grid grid--large">
                <div class="grid__item grid__item--1/1">
                  <label
                    for="cardpanInput"
                    class="form-input__label"
                  >{{ $t('payment.cc.cardnumber') }}:</label>
                  <span
                    id="cardpan"
                    class="inputIframe"
                  />
                </div>
              </div>

              <div class="grid grid--large">
                <div
                  id="expireInput"
                  class="grid__item grid__item--1/3"
                >
                  <label
                    for="cardexpiremonth"
                    class="form-input__label"
                  >{{ $t('payment.cc.expireMonth') }}:</label>
                  <span
                    id="cardexpiremonth"
                    class="inputIframe"
                  />
                </div>
                <div class="grid__item grid__item--1/3">
                  <label
                    for="cardexpireyear"
                    class="form-input__label"
                  >{{ $t('payment.cc.expireYear') }}:</label>
                  <span
                    id="cardexpireyear"
                    class="inputIframe"
                  />
                </div>
                <div class="grid__item grid__item--1/3">
                  <label
                    for="cvcInput"
                    class="form-input__label"
                  >{{ $t('payment.cc.cvc') }}:</label>
                  <span
                    id="cardcvc2"
                    class="inputIframe"
                  />
                </div>
              </div>

              <div id="errorOutput" />

              <div class="payment__data--buttons">
                <action
                  color="primary"
                  @click="checkCC"
                >
                  {{ $t('payment.label.paynow') }}
                </action>
                <action @click="cancelCC">
                  {{ $t('payment.label.cancel') }}
                </action>
              </div>

              <div class="payment__info">
                <span class="payment__info--header">{{ $t('payment.label.infoHeader') }}</span>
                <span class="payment__info--text">{{ $t('payment.label.infoText') }}</span>
              </div>
            </fieldset>
          </div>

          <div
            v-show="showSB"
            class="payment__data"
          >
            <headline class="personal-information__sub-title personal-information__header">
              {{ $t('payment.sb.title') }}
            </headline>

            <fieldset>
              <div
                v-if="loadingPayment"
                class="payment__overlay"
              >
                <div class="payment__overlay--curtain" />
                <div class="payment__overlay--content">
                  <span>{{ $t('payment.label.wait') }}</span>
                  <loader-spinner size="0.7" />
                </div>
              </div>

              <div class="form-input personal-information__input">
                <label
                  for="sb_iban"
                  class="form-input__label"
                >{{ $t('payment.sb.iban') }}</label>
                <span
                  v-show="hasError('iban')"
                  class="form-input__error"
                >{{ $t('errors.' + getError('iban')) }}</span>
                <input
                  id="sb_iban"
                  v-model="paymentData.iban"
                  class="form-input__input"
                  name="sb_iban"
                >
              </div>

              <div class="form-input personal-information__input">
                <label
                  for="sb_bic"
                  class="form-input__label"
                >{{ $t('payment.sb.bic') }}</label>
                <span
                  v-show="hasError('bic')"
                  class="form-input__error"
                >{{ $t('errors.' + getError('bic')) }}</span>
                <input
                  id="sb_bic"
                  v-model="paymentData.bic"
                  class="form-input__input"
                  name="sb_bic"
                >
              </div>

              <div class="payment__data--buttons">
                <action
                  color="primary"
                  @click="checkSB"
                >
                  {{ $t('payment.label.paynow') }}
                </action>
                <action @click="cancelSB">
                  {{ $t('payment.label.cancel') }}
                </action>
              </div>

              <div class="payment__info">
                <span class="payment__info--header">{{ $t('payment.label.infoHeader') }}</span>
                <span class="payment__info--text">{{ $t('payment.label.infoText') }}</span>
              </div>
            </fieldset>
          </div>
        </div>
      </section>
    </form>

    <section
      v-else
      class="personal-information"
    >
      <header class="personal-information__header">
        <headline>{{ $t('title') }}</headline>
      </header>

      <div class="personal-information__content">
        <p class="personal-information__empty">
          {{ $t('emptyCart') }}
        </p>
      </div>

      <footer class="personal-information__footer">
        <action-link
          v-if="reservation"
          :router-link="$t('ticketReservation.link')"
          color="primary"
          exact
        >
          <icon
            type="chevron-left"
            :size="0.75"
          />
          {{ $t('ticketReservation.text') }}
        </action-link>
        <action-link
          v-else
          :router-link="$t('ticketBooking.link')"
          color="primary"
          exact
        >
          <icon
            type="chevron-left"
            :size="0.75"
          />
          {{ $t('ticketBooking.text') }}
        </action-link>
      </footer>
    </section>

    <modal
      v-if="showError"
      :title="$t('errors.title')"
      size="medium"
      no-close
      @close="showError = false"
    >
      <p>{{ $t('errors.message') }}</p>

      <template #footer>
        <action
          color="primary"
          @click="showError = false"
        >
          Ok
        </action>
      </template>
    </modal>

    <modal
      v-if="showNoPriceHint"
      :title="$t('noPrice.title')"
      size="medium"
      @close="showNoPriceHint = false"
    >
      <p>{{ $t('noPrice.message') }}</p>

      <template #footer>
        <action
          color="primary"
          @click="closePriceHint"
        >
          {{ $t('noPrice.continue') }}
        </action>
      </template>
    </modal>
  </div>
</template>

<script>
import jump from 'jump.js'

import action from './action.vue'
import actionLink from './actionLink.vue'
import buttonGroup from './buttonGroup.vue'
import CCartBooking from './cartBooking.vue'
import CCartTimer from './CCartTimer.vue'
import headline from './headline.vue'
import icon from './icon.vue'
import loaderSpinner from './loaderSpinner.vue'
import modal from './modal.vue'

import { countrySorting, countryLabels } from '../functions/countries.js'
import api from '../api.js'
import errors from '../functions/errors.js'
import eventBus from '../eventBus.js'

import { GAP_GIFT_CARD } from '../settings.js'

export default {
  name: 'CPersonalInformation',

  components: {
    action,
    actionLink,
    buttonGroup,
    CCartBooking,
    CCartTimer,
    headline,
    icon,
    loaderSpinner,
    modal
  },

  props: {
    reservation: Boolean
  },

  data () {
    return {
      showError: false,
      errors: {},
      personalInformation: {
        firstName: '',
        lastName: '',
        email1: '',
        email2: '',
        selectedCountries: [],
        wasInMiWuLa: [],
        surveyTypes: [],
        names: [],
        addresses: [],
        locations: [],
        phones: [],
        newsletter: true,
        mergeTickets: true,
        terms: false
      },
      showNoPriceHint: false,

      payments: [],
      selectedPayment: null,
      loadingPayment: false,

      cciframe: null,

      showCC: false, // creditcard form
      showSB: false, // online transfer form (GiroPay, sofortüberweisung)
      paymentData: {}
    }
  },

  computed: {
    isGiftCardOrder () {
      return (this.$store.state.cart.tickets.gap === GAP_GIFT_CARD || this.$store.state.cart.events.gap === GAP_GIFT_CARD)
    },
    countrySorting () {
      return countrySorting(this.$i18n.locale)
    },
    countryLabels () {
      return countryLabels(this.$i18n.locale)
    },
    totalTicketCount () {
      let result = 0
      if ('tickets' in this.$store.state.cart) {
        result += this.$store.state.cart.tickets.total_articles
      }

      if ('events' in this.$store.state.cart) {
        result += this.$store.state.cart.events.total_articles
      }

      return result
    }
  },

  watch: {
    'personalInformation.firstName': function (value) {
      this.checkField('firstName', value, ['required'])
    },
    'personalInformation.lastName': function (value) {
      this.checkField('lastName', value, ['required'])
    },
    'personalInformation.email1': function (value) {
      this.checkField('email1', value, ['required', 'email'])
    },
    'personalInformation.email2': function (value) {
      this.checkField('email2', value, ['required', 'email', 'same'], this.personalInformation.email1)
    },
    'personalInformation.terms': function (value) {
      this.checkField('terms', value, ['terms'])
    },
    'personalInformation.selectedCountries': function (value) {
      if (this.reservation) {
        return true
      }

      for (const index in value) {
        this.checkField('selectedCountries_' + index, parseInt(value[index]), ['higherThan'], 0)
      }
    },
    'personalInformation.wasInMiWuLa': function (value) {
      if (this.reservation) {
        return true
      }

      for (const index in value) {
        this.checkField('wasInMiWuLa_' + index, parseInt(value[index]), ['required', 'between'], [-1, 1])
      }
    }
  },

  async created () {
    this.resetErrors()
    await this.$store.dispatch('getCart', { dontResetSelection: true })
    this.$tracking.eetCheckoutPersonalDataView()

    if (this.$store.state.payments.length === 0) {
      api.get('checkout/payments/').then(response => {
        this.$store.state.payments = response.data
        this.payments = response.data
        for (const payment of this.payments) {
          payment.processing = false
        }
        this.loading = false
      }, error => {
        this.loading = false
        eventBus.emit('handleError', error.response.data.error)
      })
    } else {
      this.payments = this.$store.state.payments
      for (const payment of this.payments) {
        payment.processing = false
      }
      this.loading = false
    }

    if (this.reservation) {
      // If there are more than these two requests, the chain of promises will get to nested
      this.$store.dispatch('removeFromCart', { endpoint: 'tickets' }).then(() => {
        this.$store.dispatch('removeFromCart', { endpoint: 'vouchers' })
      }, () => {
        this.$store.dispatch('removeFromCart', { endpoint: 'vouchers' })
      })
    } else {
      this.$store.dispatch('removeFromCart', { endpoint: 'reservations' })
    }

    const flags = []
    const countries = []
    const names = []
    const addresses = []
    const locations = []
    const phones = []

    const surveyCount = this.totalTicketCount

    for (let i = 0; i < surveyCount; i++) {
      flags[i] = this.personalInformation.wasInMiWuLa[i] || false
      countries[i] = this.personalInformation.selectedCountries[i] || 0
      names[i] = this.personalInformation.names[i] || ''
      addresses[i] = this.personalInformation.addresses[i] || ''
      locations[i] = this.personalInformation.locations[i] || ''
      phones[i] = this.personalInformation.phones[i] || ''
    }

    const types = []
    let index = 0

    if ('tickets' in this.$store.state.cart) {
      for (const tType in this.$store.state.cart.tickets.articles) {
        for (let i = 0; i < this.$store.state.cart.tickets.articles[tType].count; i++) {
          types[index] = tType
          index++
        }
      }
    }

    if ('events' in this.$store.state.cart) {
      for (const tType in this.$store.state.cart.events.articles) {
        for (let i = 0; i < this.$store.state.cart.events.articles[tType].count; i++) {
          types[index] = tType
          index++
        }
      }
    }

    this.personalInformation.wasInMiWuLa = flags
    this.personalInformation.selectedCountries = countries
    this.personalInformation.surveyTypes = types
    this.personalInformation.names = names
    this.personalInformation.addresses = addresses
    this.personalInformation.locations = locations
    this.personalInformation.phones = phones

    this.$nextTick(function () {
      this.resetErrors()
    })
  },

  mounted () {
    const payoneScript = document.createElement('script')
    payoneScript.setAttribute('src', 'https://secure.pay1.de/client-api/js/v1/payone_hosted.js')
    document.head.appendChild(payoneScript)

    window.checkCCCallback = this.checkCCCallback
  },

  methods: {
    trackReturning (returning) {
      this.$tracking.eetCheckoutPersonalDataReturning(returning)
    },

    trackNewsletter () {
      this.$tracking.eetCheckoutPersonalDataViewNewsletter(this.personalInformation.newsletter)
    },

    ticketType (aIndex) {
      const articleId = this.$store.state.cartArticleTypes[aIndex - 1]

      if (articleId in this.$store.state.articles) {
        return this.$store.state.articles[articleId]['text_' + this.$i18n.locale]
      }

      return ''
    },

    resetErrors () {
      this.errors = {}
    },

    checkFields () {
      this.checkField('firstName', this.personalInformation.firstName, ['required'])
      this.checkField('lastName', this.personalInformation.lastName, ['required'])
      this.checkField('email1', this.personalInformation.email1, ['required', 'email'])
      this.checkField('email2', this.personalInformation.email2, ['required', 'email', 'same'], this.personalInformation.email1)

      if (!this.isGiftCardOrder && !this.reservation) {
        this.checkField('terms', this.personalInformation.terms, ['terms'])
        for (const index in this.personalInformation.selectedCountries) {
          this.checkField('selectedCountries_' + index, parseInt(this.personalInformation.selectedCountries[index]), ['higherThan'], 0)
        }
        for (const index in this.personalInformation.wasInMiWuLa) {
          this.checkField('wasInMiWuLa_' + index, parseInt(this.personalInformation.wasInMiWuLa[index]), ['required', 'between'], [-1, 1])
        }
      }
    },

    checkField (fieldName, value, checks, value2) {
      this.removeError(fieldName)
      for (const i in checks) {
        switch (checks[i]) {
          case 'required':
          {
            if (typeof value === 'undefined' || value === '') {
              this.setError(fieldName, 'required')
              return false
            }
            break
          }
          case 'email':
          {
            // eslint-disable-next-line no-useless-escape
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            if (!re.test(value)) {
              this.setError(fieldName, 'email')
              return false
            }
            break
          }
          case 'same':
          {
            if (value !== value2) {
              this.setError(fieldName, 'same')
              return false
            }
            break
          }
          case 'terms':
          {
            if (value === false) {
              this.setError(fieldName, 'terms')
              return false
            }
            break
          }
          case 'higherThan':
          {
            if (value <= value2) {
              this.setError(fieldName, 'higherThan')
              return false
            }
            break
          }
          case 'between':
          {
            if (isNaN(value) || value < value2[0] || value > value2[1]) {
              this.setError(fieldName, 'between')
              return false
            }
            break
          }
        }
      }
      return true
    },

    anyErrors () {
      if (this.errors.length === 0) {
        return false
      }

      for (const i in this.errors) {
        if (this.errors[i] !== null) {
          return true
        }
      }

      return false
    },

    removeError (fieldName) {
      this.errors[fieldName] = null
    },

    setError (fieldName, message) {
      this.errors[fieldName] = message
    },

    hasError (fieldName) {
      if (fieldName in this.errors) {
        return (this.errors[fieldName] !== null)
      }
      return false
    },

    getError (fieldName) {
      if (fieldName in this.errors && this.errors[fieldName] !== null) {
        return this.errors[fieldName]
      }
      return 'noError'
    },

    /**
     * This is the entry point when the payment button is pressed.
     */
    validateBeforeSubmit () {
      this.checkFields()

      if (this.anyErrors() === false) {
        this.checkCart()
      } else {
        this.showError = true
      }
    },

    checkCart () {
      this.showNoPriceHint = false

      if (!this.reservation) {
        if ('articles' in this.$store.state.cart.tickets) {
          for (const aIndex in this.$store.state.cart.tickets.articles) {
            if (this.$store.state.cart.tickets.articles[aIndex].subtotal === 0) {
              this.showNoPriceHint = true
              break
            }
          }
        }

        if ('articles' in this.$store.state.cart.events) {
          for (const aIndex in this.$store.state.cart.events.articles) {
            if (this.$store.state.cart.events.articles[aIndex].subtotal === 0) {
              this.showNoPriceHint = true
              break
            }
          }
        }

        if (!this.showNoPriceHint) {
          for (const vIndex in this.$store.state.cart.vouchers) {
            for (const tIndex in this.$store.state.cart.vouchers[vIndex]) {
              if (this.$store.state.cart.vouchers[vIndex][tIndex].price === 0) {
                this.showNoPriceHint = true
                break
              }
            }
          }
        }
      }

      if (!this.showNoPriceHint) {
        this.startPayment(this.selectedPayment)
      }
    },

    closePriceHint () {
      this.showNoPriceHint = false
      this.startPayment(this.selectedPayment)
    },

    startReservation () {
      this.loadingPayment = true
      this.beginCheckout()
    },

    setPayment (payment) {
      this.selectedPayment = payment
    },

    startPayment (payment) {
      // Disable all other payment buttons
      for (const pay of this.payments) {
        pay.processing = (pay !== payment)
      }

      // At his point we might have to display various interfaces depending on the payment type
      // For example, the cc payment needs an iFrame to fetch the paytoken. Other might follow
      // This is a simple if switch as we only have two different things to do here. It might be
      // worth thinking about extending this, as soon as we have the need for other processes.
      if (payment.clearingtype === 'cc') {
        this.initCC(payment.wallettype)
      } else if (payment.clearingtype === 'sb') {
        this.initSB(payment.wallettype)
      } else {
        this.beginCheckout()
      }
    },

    beginCheckout (pseudocardpan = null, iban = null, bic = null) {
      this.loadingPayment = true

      const checkoutData = {
        firstname: this.personalInformation.firstName,
        lastname: this.personalInformation.lastName,
        email: this.personalInformation.email1,
        clearingtype: this.selectedPayment ? this.selectedPayment.clearingtype : '',
        wallettype: this.selectedPayment ? this.selectedPayment.wallettype : '',
        language: this.$i18n.locale,
        newsletter: this.personalInformation.newsletter,
        giftcardtemplate: this.$store.state.selectedGiftCardTemplate ? this.$store.state.selectedGiftCardTemplate.id : 0,
        giftcardorder: this.isGiftCardOrder,
        merge_pdf: this.personalInformation.mergeTickets
      }

      const surveyData = {}

      for (const surveyIndex in this.personalInformation.surveyTypes) {
        const ticketType = this.personalInformation.surveyTypes[surveyIndex]
        let country = parseInt(this.personalInformation.selectedCountries[surveyIndex])

        // set the "not specified" to 0, we need it to be 1000 in the interface
        if (country === 1000) {
          country = 0
        }

        let amount = 0

        if (parseInt(this.personalInformation.wasInMiWuLa[surveyIndex]) === 1) {
          amount = 1
        }

        if (!(ticketType in surveyData)) {
          surveyData[ticketType] = []
        }

        surveyData[ticketType].push([
          country,
          amount,
          this.personalInformation.names[surveyIndex],
          this.personalInformation.addresses[surveyIndex],
          this.personalInformation.locations[surveyIndex],
          this.personalInformation.phones[surveyIndex]
        ])
      }

      checkoutData.survey = surveyData

      if (pseudocardpan) {
        checkoutData.pseudocardpan = pseudocardpan
      }

      if (iban && bic) {
        checkoutData.iban = iban
        checkoutData.bic = bic
      }

      api.post('checkout/begin/', checkoutData).then(response => {
        this.$store.commit('setOrderReference', response.data.order_reference)
        this.loadingPayment = false

        if (response.data.payment_required === true) {
          const paymentMethod = `${this.selectedPayment.clearingtype}_${this.selectedPayment.wallettype}`
          this.$tracking.eetCheckoutPayment(paymentMethod)

          if (response.data.redirect === true) {
            window.location = response.data.redirect_url
          } else {
            this.$router.push({
              name: `booking-confirmation-${this.$i18n.locale}`,
              params: { referenceid: response.data.oref }
            })
          }
        } else {
          this.$tracking.eetCheckoutPayment('none')

          let routeName = ''

          if (this.reservation) {
            routeName = `reservation-process-${this.$i18n.locale}`
          } else {
            routeName = `booking-confirmation-${this.$i18n.locale}`
          }

          this.$router.push({ name: routeName })
        }

        this.$store.commit('reset')
      }, error => {
        // @Incomplete: should we display the specific error from the backend here?
        eventBus.emit('handleError', errors(this.$i18n.locale)[error.response.data.code])
        this.loadingPayment = false

        for (const payment of this.payments) {
          payment.processing = false
        }
      })
    },

    /**
     * Initialize the CC iframe provided by PayOne
     */
    initCC (cardtype) {
      const config = {
        fields: {
          cardpan: {
            selector: 'cardpan',
            type: 'text'
          },
          cardcvc2: {
            selector: 'cardcvc2',
            type: 'password',
            size: '4',
            maxlength: '4',
            length: { A: 4, V: 3, M: 3, J: 0 }
          },
          cardexpiremonth: {
            selector: 'cardexpiremonth',
            type: 'select',
            size: '2',
            maxlength: '2'
          },
          cardexpireyear: {
            selector: 'cardexpireyear',
            type: 'select'
          }
        },
        defaultStyle: {
          input: 'display: block; width: 100%; min-height: 2em; padding: 0.3125em 0.75em; font-size: 1em; font-family: -apple-system, "BlinkMacSystemFont", "Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif; border: 0.0625rem solid #ccc; border-radius: 1em; outline: none;',
          // At this point would usually redefine the look of select boxes, to make them look like all other select
          // boxes on the site. Unfortunately, this is not possible in this case, since the CSS attribute "url" is not
          // allowed. Quote from Payone doc: "If “url” is used the style will be ignored as PCI DSS does not allow
          // external ressources."
          // As a remark, we would not load external sources, but use data:image in order to draw a dropdown arrow
          // in place. This is pretty much a bug in the PayOne system, but I can't see any chance, that this will be
          // fixed anytime soon.
          // The arrow code would be
          // background-image: url(\"data:image/svg+xml;charset=utf8,<svg fill='#34485e' viewBox='0 0 24 24' width='24' height='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>\");
          select: "-webkit-appearance: none; -moz-appearance: none; appearance: none; display: block; width: 100%; min-height: 2em; padding: 0.3125em 0.75em; font-size: 1em; background-color: transparent; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; border: 0.0625rem solid #ccc; border-radius: 1em; outline: none; background-repeat: no-repeat; background-position: center right 0.5em; background-size: 1.5em;",
          iframe: {
            height: '35px',
            width: '100%'
          }
        },
        error: 'errorOutput',
        language: (this.$i18n.locale === 'de') ? Payone.ClientApi.Language.de : Payone.ClientApi.Language.en
      }

      api.get('checkout/ccrequest/').then(response => {
        const ccrequest = response.data
        this.resetIframes()
        /* global Payone */
        this.cciframe = new Payone.ClientApi.HostedIFrames(config, ccrequest)
        this.cciframe.setCardType(cardtype)
        this.showCC = true
        this.jumpToPaymentForm()
      })
    },

    cancelCC () {
      this.loadingPayment = false
      this.showCC = false
      this.resetIframes()
      this.resetPayments()
      this.jumpToPaymentSelection()
    },

    resetIframes () {
      this.cciframe = null
      const spans = document.getElementsByClassName('inputIframe')
      for (const span of spans) {
        const frames = span.getElementsByTagName('iframe')
        for (const frame of frames) {
          span.removeChild(frame)
        }
      }
    },

    resetPayments () {
      for (const payment of this.payments) {
        payment.processing = false
      }
    },

    /**
     * This is called when the user presses the PAY button on the CC form
     */
    checkCC () {
      if (this.cciframe.isComplete()) {
        this.loadingPayment = true
        this.cciframe.creditCardCheck('checkCCCallback')
      } else {
        this.showError = true
      }
    },

    /**
     * This is the callback from the cc-form
     * @param response
     */
    checkCCCallback (response) {
      this.loadingPayment = false
      if (response.status === 'VALID') {
        this.beginCheckout(response.pseudocardpan)
      } else {
        this.showError = true
      }
    },

    initSB () {
      this.paymentData = {}
      this.showSB = true
      this.jumpToPaymentForm()
    },

    cancelSB () {
      this.paymentData = {}
      this.loadingPayment = false
      this.showSB = false
      this.resetPayments()
      this.jumpToPaymentSelection()
    },

    checkSB () {
      this.checkField('iban', this.paymentData.iban, ['required'])
      this.checkField('bic', this.paymentData.bic, ['required'])

      if (this.anyErrors() === false) {
        this.beginCheckout(null, this.paymentData.iban, this.paymentData.bic)
      } else {
        this.showError = true
      }
    },

    jumpToPaymentForm () {
      jump('#payment_form', { duration: 500 })
    },

    jumpToPaymentSelection () {
      jump('#payment_selection', { duration: 500 })
    }
  }
}
</script>

<i18n locale="en">
{
  "errors": {
    "noError": " ",
    "required": "This field is required",
    "email": "This is not a valid e-mail address",
    "same": "The e-mail addresses do not match.",
    "terms": "Please accept the terms and conditions",
    "higherThan": "Please make a selection",
    "between": "Please make a selection",
    "title": "Ooops",
    "message": "Please check your input. One or more fields are not filled in correctly."
  },
  "urls": {
    "success": "/booking/confirmation"
  },
  "title": "Enter your personal details",
  "formFields": {
    "firstName": "First name",
    "lastName": "Last name",
    "email": "Email address",
    "surveyName": "Firstname and Lastname",
    "surveyAddress": "Street and Nr.",
    "surveyLocation": "ZIP-Code and City",
    "surveyPhone": "Phone",
    "emailRepeat": "Repeat email address",
    "newsletter": "Please keep me updated regularly about news from Wunderland.",
    "terms": {
      "label1": "I agree to the",
      "label2": ".",
      "linkText": "terms and conditions",
      "routerLink": "https://www.miniatur-wunderland.com/services/terms-conditions/",
      "reservation": "By reserving you accept the"
    },
    "visited": {
      "yes": "Yes",
      "no": "No",
      "none": "No answer"
    },
    "mergeTickets": "Merge all tickets into a single PDF.",
    "mergeGiftcards": "Merge all gift-cards into the least amount of PDFs possible."
  },
  "visitorOrigin": {
    "note": "We kindly ask every guest about their country of origin to populate our interactive charts showing all visitor's origins. We would appreciate if you take the time to fill out the survey below. This will also speed up the admission process.",
    "person": "Person",
    "comesFrom": "is from",
    "country": "Country",
    "federalState": "Federal State",
    "alreadyVisited": "Has visited the Miniatur Wunderland before"
  },
  "coronaHeader": "Necessary COVID-19 contact data entry",
  "coronaHint": "Due to the Hamburger Corona Regulation (HmbSARS-CoV-2-EindämmungsVO § 7 para. 1), we are obliged to consult Contact our visitors. This data will be forwarded by us to the responsible health authority only on request and will be deleted from our database 4 weeks after the visit to the Miniatur Wunderland.",
  "changeReservation": {
    "text": "Change reservation",
    "link": "/reservation"
  },
  "continueOrder": {
    "title": "Pay now with:",
    "textCC": "Pay with <strong>credit card</strong>",
    "textPP": "Pay with <strong>PayPal</strong>",
    "link": "/booking/payment"
  },
  "continueReservation": {
    "text": "Reserve now",
    "link": "/reservation/confirmation"
  },
  "mandatoryFields": "Required fields",
  "emptyCart": "Your shopping cart is empty!",
  "ticketBooking": {
    "text": "Ticket Booking",
    "link": "/booking"
  },
  "ticketReservation": {
    "text": "Ticket Reservation",
    "link": "/reservation"
  },
  "noPrice": {
    "title": "Please note",
    "message": "Tickets at no charge for kids will not appear in the following payment form. All tickets will of course be included again in the final booking confirmation.",
    "continue": "Proceed to payment"
  },
  "payment": {
    "label": {
      "wait": "Please wait…",
      "paynow": "Pay now",
      "cancel": "Cancel",
      "infoHeader": "Your safety is important to us:",
      "infoText": "Your payment data will only be processed and saved by our service provider Payone. We do not save your payment data at any time!"
    },
    "cc": {
      "title": "Credit card information",
      "cardnumber": "Card number",
      "cvc": "CVC",
      "expireYear": "Expiry year",
      "expireMonth": "Expiry month",
      "firstname": "First name",
      "lastname": "Last name"
    },
    "sb": {
      "title": "Bank Informationen",
      "iban": "IBAN",
      "bic": "BIC"
    }
  }
}
</i18n>

<i18n locale="de">
{
  "errors": {
    "noError": " ",
    "required": "Dieses Feld ist eine Pflichtangabe.",
    "email": "Bitte geben Sie eine gültige E-Mail Adresse ein.",
    "same": "Die E-Mail Adressen unterscheiden sich.",
    "terms": "Bitte akzeptieren Sie die AGB.",
    "higherThan": "Bitte machen Sie eine Angabe.",
    "between": "Bitte machen Sie eine Angabe.",
    "title": "Ups",
    "message": "Bitte überprüfen Sie Ihre Eingabe. Ein oder mehrere Felder wurden nicht korrekt ausgefüllt."
  },
  "urls": {
    "success": "/buchung/bestaetigung"
  },
  "title": "Eingabe Ihrer persönlichen Daten",
  "formFields": {
    "firstName": "Vorname",
    "lastName": "Nachname",
    "email": "E-Mail-Adresse",
    "emailRepeat": "E-Mail-Adresse wiederholen",
    "newsletter": "Bitte informieren Sie mich regelmäßig über Neuigkeiten aus dem Wunderland.",
    "terms": {
      "label1": "Ich stimme den",
      "label2": "zu.",
      "linkText": "AGB und Nutzungsbedingungen",
      "routerLink": "https://www.miniatur-wunderland.de/service/agb/",
      "reservation": "Mit der Reservierung akzeptiere ich die"
    },
    "visited": {
      "yes": "Ja",
      "no": "Nein",
      "none": "Keine Angabe"
    },
    "surveyName": "Vor- und Nachname",
    "surveyAddress": "Straße und Hausnummer",
    "surveyLocation": "PLZ und Stadt",
    "surveyPhone": "Telefon",
    "mergeTickets": "Alle Tickets in einem PDF zusammenfassen.",
    "mergeGiftcards": "Alle Gutscheine in möglichst wenigen PDFs zusammenfassen."
  },
  "visitorOrigin": {
    "note": "Für unsere schöne interaktive Besucherherkunftstafel fragen wir jeden Gast nach seiner Herkunft. Wir freuen uns sehr, wenn Sie sich die Zeit nehmen und kurz Ihre Herkunft auswählen, dann geht es bei der Ankunft im Wunderland schneller.",
    "person": "Person",
    "comesFrom": "kommt aus",
    "country": "Land",
    "federalState": "Bundesland",
    "alreadyVisited": "Hat bereits das Miniatur Wunderland besucht"
  },
  "coronaHeader": "Notwendige Corona-Kontaktdaten-Erfassung",
  "coronaHint": "Auf Grund der Hamburger Corona Verordnung (HmbSARS-CoV-2-EindämmungsVO § 7 Abs. 1) sind wir verpflichtet, Kontaktdaten von unseren Besuchern abzufragen. Diese Daten werden von uns ausschließlich auf Anforderung an das zuständige Gesundheitsamt weitergeleitet und werden 4 Wochen nach dem Besuch im Miniatur Wunderland aus unserem Datenbestand gelöscht.",
  "changeReservation": {
    "text": "Reservierung ändern",
    "link": "/reservierung"
  },
  "continueOrder": {
    "title": "Jetzt bezahlen mit:",
    "textCC": "Mit <strong>Kreditkarte</strong> zahlen",
    "textPP": "Mit <strong>PayPal</strong> zahlen",
    "link": "/buchung/zahlungsart"
  },
  "continueReservation": {
    "text": "Jetzt reservieren",
    "link": "/reservierung/bestaetigung"
  },
  "mandatoryFields": "Pflichtfelder",
  "emptyCart": "Sie haben keine Artikel im Warenkorb!",
  "ticketBooking": {
    "text": "Zur Ticketbuchung",
    "link": "/buchung"
  },
  "ticketReservation": {
    "text": "Zur Ticketreservierung",
    "link": "/reservierung"
  },
  "noPrice": {
    "title": "Hinweis",
    "message": "Bitte beachten Sie, dass kostenlose Tickets für Kinder in der folgenden Zahlungs-Maske nicht erscheinen. In der abschließenden Buchung sind sämtliche Tickets selbstverständlich enthalten.",
    "continue": "Weiter zur Zahlung"
  },
  "payment": {
    "label": {
      "wait": "Bitte warten…",
      "paynow": "Jetzt bezahlen",
      "cancel": "Abbrechen",
      "infoHeader": "Ihre Sicherheit ist uns wichtig:",
      "infoText": "Ihre Zahlungsdaten werden ausschließlich von unserem Dienstleister Payone verarbeitet und gespeichert. Eine Speicherung Ihrer Zahlungsdaten erfolgt bei uns zu keinem Zeitpunkt!"
    },
    "cc": {
      "title": "Kreditkarten Informationen",
      "cardnumber": "Kartennummer",
      "cvc": "CVC",
      "expireYear": "Ablaufjahr",
      "expireMonth": "Ablaufmonat",
      "firstname": "Vorname",
      "lastname": "Nachname"
    },
    "sb": {
      "title": "Bank Informationen",
      "iban": "IBAN",
      "bic": "BIC"
    }
  }
}
</i18n>

<style lang="scss">
@import "../css/variables";
@import "../css/mixins";

.personal-information {
  @include card;
}

.personal-information__header {
  margin-bottom: $gutter-sm;
  text-align: center;

  @media (min-width: $breakpoint-md) {
    margin-bottom: $gutter-md;
  }
}

.personal-information__timer {
  margin-top: $gutter-sm;
}

.personal-information__note {
  font-size: 0.875em;
}

.personal-information__input {
  margin-bottom: $gutter-sm;
}

.personal-information__footer {
  margin-top: $gutter-md;

  .loader-spinner__circle {
    stroke: #fff;
  }
}

.personal-information__fine-print {
  margin: 0 0 $gutter-sm;

  font-size: 0.875em;
  color: $color-strong;
}

.personal-information__sub-title {
  margin: $gutter-sm 0;
  text-align: center;

  @media (min-width: $breakpoint-md) {
    margin: $gutter-md 0;
  }
}

.personal-information__terms {
  display: flex;
  flex-direction: column;
  align-items: center;

  // Hackerman 😎
  &#{&} {
    margin-bottom: $gutter-md;
  }
}

.personal-information__empty {
  margin-bottom: $gutter-sm;

  font-size: 1.125em;
  font-weight: 700;
  text-align: center;

  @media (min-width: $breakpoint-md) {
    font-size: 1.25em;
  }
}

.payment__container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: $gutter-sm;
}

.payment__wrapper {
  svg {
    height: 4em;
    vertical-align: middle;

    @media (min-width: $breakpoint-sm) {
      height: 5em;
    }

    @media (min-width: $breakpoint-md) {
      height: 6em;
    }
  }
}

.payment__overlay {
  div {
    z-index: 10;
    position: absolute;
  }

  .payment__overlay--curtain {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 10px;
    background-color: rgb(255 255 255 / 0.85);
  }

  .payment__overlay--content {
    top: 30%;
    left: 0;
    width: 100%;
    height: 100%;
    justify-content: center;
    text-align: center;

    span {
      display: block;
      margin: $gutter-sm;
    }
  }
}

.payment__data {
  position: relative;
}

.payment__data--buttons {
  margin: $gutter-sm 0;
  text-align: right;

  @media (max-width: $breakpoint-md) {
    margin: $gutter-md 0;

    button {
      margin: $gutter-xs 0;
    }
  }
}

.payment__info {
  font-size: 0.8rem;
  color: $color-strong;

  .payment__info--header {
    font-weight: 700;
    display: block;
  }
}
</style>
